module.exports = __webpack_public_path__ + "img/drehmoment.0f755ded.png";